import { render, staticRenderFns } from "./ModalDefault.vue?vue&type=template&id=537265d9&"
import script from "./ModalDefault.vue?vue&type=script&lang=ts&"
export * from "./ModalDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports